import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Submitting } from '../common/Submitting'
import currency from 'currency.js'

const COUPON_NOT_APPLIED = ' - coupon not applied'

export const RemoveAppliedCoupon = ({
  couponCode,
  couponAmount,
  isCouponApplying,
  setValue,
  applyCoupon,
  error,
  isCheckoutCartLoading
}) => (
  <div className="row middle-xs">
    <div className="col-xs-12 col-md-3 start-xs end-md">
      <label htmlFor="coupon">Coupon Applied:</label>
    </div>
    <div className="col-xs-12 col-md-6">
      <label>
        {`${couponCode} `}
        <strong>
          ({currency(couponAmount, { formatWithSymbol: true }).format()})
        </strong>
      </label>
      {error && (
        <div className="slide error">
          {error.response.data.message || error.response.data}
        </div>
      )}
    </div>
    <div className="col-xs-12 col-md-3 end-xs">
      {isCouponApplying || isCheckoutCartLoading ? (
        <Submitting text="Changing" />
      ) : (
        <button
          type="button"
          className="secondary"
          onClick={() => {
            applyCoupon('')
            setValue('')
          }}
        >
          Change
        </button>
      )}
    </div>
  </div>
)

export const AddCoupon = ({
  value,
  isCouponApplying,
  setValue,
  applyCoupon,
  error,
  isCheckoutCartLoading
}) => (
  <div className="row middle-xs">
    <div className="col-xs-12 col-md-3 start-xs end-md">
      <label htmlFor="coupon">Coupon Code</label>
    </div>
    <div className="col-xs-12 col-md-6">
      <input
        id="coupon"
        type="text"
        value={value}
        onChange={evt => setValue(evt.target.value)}
        onKeyDown={e => e.keyCode === 13 && applyCoupon(value)}
      />
      {error && (
        <div className="slide error">
          {error.response.data.message ||
            error.response.data + COUPON_NOT_APPLIED}
        </div>
      )}
    </div>
    <div className="col-xs-12 col-md-3 end-xs">
      {isCouponApplying ? (
        <Submitting text="Applying" />
      ) : (
        <button
          type="button"
          className="secondary"
          disabled={!value || isCheckoutCartLoading}
          onClick={event => {
            event.preventDefault()
            applyCoupon(value)
          }}
        >
          Apply
        </button>
      )}
    </div>
  </div>
)

class ApplyCoupon extends Component {
  constructor(props) {
    super(props)
    this.state = { value: '' }

    this.setValue = this.setValue.bind(this)
  }

  setValue(value) {
    this.setState({ value: value })
  }

  render() {
    const {
      applyCoupon,
      error,
      isCouponApplying,
      couponApplied,
      couponCode,
      couponAmount,
      isCheckoutCartLoading
    } = this.props
    return couponApplied ? (
      <RemoveAppliedCoupon
        couponCode={couponCode}
        couponAmount={couponAmount}
        isCouponApplying={isCouponApplying}
        setValue={this.setValue}
        applyCoupon={applyCoupon}
        error={error}
        isCheckoutCartLoading={isCheckoutCartLoading}
      />
    ) : (
      <AddCoupon
        value={this.state.value}
        isCouponApplying={isCouponApplying}
        setValue={this.setValue}
        applyCoupon={applyCoupon}
        error={error}
        isCheckoutCartLoading={isCheckoutCartLoading}
      />
    )
  }
}

ApplyCoupon.propTypes = {
  applyCoupon: PropTypes.func,
  error: PropTypes.object,
  isCheckoutCartLoading: PropTypes.bool
}

export default ApplyCoupon
